import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface PageState {
  title?: string;
}

export const initialState: PageState = {
  title: ''
};

export interface ActionType {
  type: string;
  payload: PageState;
}

export const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    PAGE_INIT: () => {
      const _state = {
        ...initialState
      };
      return _state;
    },
    PAGE_UPDATE: (state, action: PayloadAction<PageState>) => {
      const _state = {
        ...state,
        ...(action.payload || {})
      };
      return _state;
    }
  }
});

export const { PAGE_INIT, PAGE_UPDATE } = pageSlice.actions;

export default pageSlice.reducer;
